import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-success-payment-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule],
  template: `
    <div class="success-wrapper">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h2 class="title">¡Pagado con éxito!</h2>
      <p class="subtitle">Tu pago fue procesado correctamente.</p>
    </div>
  `,
  styles: [
    `
      .success-wrapper {
        text-align: center;
        padding: 24px 20px 12px;
        max-width: 340px;
      }
      .success-icon {
        font-size: 72px;
        width: 72px;
        height: 72px;
        color: #2e7d32;
        margin-bottom: 12px;
      }
      .title {
        margin: 0 0 8px;
        font-size: 20px;
        font-weight: 600;
        color: #2e7d32;
      }
      .subtitle {
        margin: 0 0 20px;
        font-size: 14px;
        color: #444;
      }
      button {
        min-width: 140px;
      }
    `,
  ],
})
export class SuccessPaymentDialogComponent {
  constructor(private dialogRef: MatDialogRef<SuccessPaymentDialogComponent>) {}
  close() {
    this.dialogRef.close();
  }
}
